import { inject, Injectable } from '@angular/core';

import { keys } from '../../constants/constants';
import { CommonPermissions, UserPermissions } from '../../models/permissions';
import { StorageService } from '../storage/storage.service';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private readonly storage = inject(StorageService);

  private permissions: UserPermissions | null = null;

  setPermissions(permissions: UserPermissions): void {
    this.permissions = permissions;
    this.storage.set<UserPermissions>(keys.permissions, permissions);
  }

  getPermissions(): UserPermissions {
    if (!this.permissions) {
      this.permissions = this.storage.get<UserPermissions>(keys.permissions) ?? {};
    }
    return this.permissions;
  }

  hasPermission(group: keyof UserPermissions, action: keyof CommonPermissions): boolean {
    return this.getPermissions()[group]?.[action] === true;
  }

  hasAnyPermission(group: keyof UserPermissions): boolean {
    const actions = this.getPermissions()[group];
    return !!actions && Object.values(actions).some(granted => granted === true);
  }

  clear(): void {
    this.permissions = null;
    this.storage.remove(keys.permissions);
  }
}
